<template lang="html">
  <div class="">
  <div class="middle-box text-center loginscreen  animated fadeInDown register">
    <div class="border">
      <h3>会员注册</h3>
        <div class="form-group row">
          <label for="staticEmail" class="col-sm-4 col-form-label col-xl-4">手机号：</label>
          <div class="col-sm-8 col-xl-8">
            <input type="text" class="form-control" name="phone" v-model="mobile"  placeholder="手机号">
          </div>
        </div>
        <!-- <div class="form-group row">
          <label for="staticEmail" class="col-sm-4 col-form-label">验证码：</label>
          <div class="col-sm-8">
            <div class="row">
              <input type="text" class="form-control col-sm-6" v-model="icode"  placeholder="">
              <div class="col-sm-6">
                <img src="" alt="">
              </div>
            </div>
          </div>
        </div> -->
        <div class="form-group row">
          <label for="staticEmail" class="col-sm-4 col-form-label col-xl-4">短信验证码：</label>
          <div class="col-sm-8 col-xl-8">
            <div class="row">
              <input type="text" class="form-control col-sm-6" v-model="vcode" name="vcode"  placeholder="短信验证码">
              <div class="col-sm-5  btn btn-primary btn-send" id="btn" :disabled="codeDisable">
                {{time}}
              </div>
            </div>
          </div>
        </div>
        <div class="form-group row">
          <label for="staticEmail" class="col-sm-4 col-form-label">设置密码：</label>
          <div class="col-sm-8">
            <input type="password" class="form-control" name="psw" v-model="psw"  placeholder="密码" @blur="checkPassword">
          </div>
        </div>
        <div class="form-group row">
          <label for="staticEmail" class="col-sm-4 col-form-label">再次输入密码：</label>
          <div class="col-sm-8">
            <input type="password" class="form-control" v-model="repsw"  placeholder="再次输入密码" @blur="checkPassword">
          </div>
        </div>
        <div class="form-group row">
          <label for="staticEmail" class="col-sm-4 col-form-label">真实姓名：</label>
          <div class="col-sm-8">
            <input type="text" class="form-control" v-model="name"  placeholder="真实姓名">
          </div>
        </div>
        <p v-show="errInfo" class="errInfo">{{errInfo}}</p>
        <!-- <div class="form-group">
            <input type="password" class="form-control" placeholder="密码" required="">
        </div> -->
        <button @click="register" class="btn btn-primary block full-width m-b">快速注册</button>
      </div>
    </div>
    <alert-model v-bind:func="alertFunc" v-bind:show="alertShow" v-on:close="catchClose" v-bind:msg="tips"></alert-model>
  </div>
</template>

<script>
import alertModel from './alert.vue'
export default {
  components:{
    alertModel
  },
  data(){
    return{
      mobile:'',
      icode:'',
      vcode:'',
      psw:'',
      repsw:'',
      name:'',
      errInfo:'',
      capt:{},
      time:'发送验证码',
      codeDisable:false,
      session:'',
      alertShow:false,
      tips:'',
      alertFunc:''
    }
  },
  methods:{
    catchClose(data){
      this.alertShow = data.show
    },
    alert(msg,func){
      this.alertShow = true
      this.tips = msg
      this.alertFunc = func
    },
    checkPassword(){
      if(this.psw&&this.repsw){
        if(this.psw != this.repsw){
          this.errInfo = "两次输入密码不一致"
          return
        }else{
          this.errInfo = ""
        }
      }
    },
    register(){
      let params ={
        mobile:this.mobile,
        password:this.psw,
        realname:this.name,
        vcode:this.vcode,
        password1:this.repsw,
      }
      const msgArr = [['mobile','手机号'],['password','密码'],['realname','姓名'],['vcode','短信验证码']]
      for(let i=0;i<msgArr.length;i++){
        if(!params[msgArr[i][0]]){
          this.errInfo = `${msgArr[i][1]}不能为空`
          return
        }
      }
      this.$axios.post('/api/wenlian/reg',this.qs.stringify(params)).then(res=>{
        if(res.data.result == 1){
          this.alert(res.data.msg,()=>{
            this.$router.push('/login')
          })
        }else{
          this.alert(res.data.msg)
        }
      })
    },
    sendCode(){
      if(this.mobile&&!this.codeDisable){
        let params = {
          mobile:this.mobile
        }
        Object.assign(params,this.capt,{sessionid:this.session})
        this.$axios.post('/api/wenlian/sendcode',this.qs.stringify(params)).then(res=>{
          this.codeDisable = true
          if(res.data.result==1){
            let total = 60
            let timer = setInterval(()=>{
              this.time = `${(total+'').length>1?total:'0'+total}s 重试`
              total--
              if(total<=0){
                clearInterval(timer)
                this.codeDisable = false
                this.time = "发送验证码"
              }
            },1000)
          }else{
            this.errInfo = res.data.msg
          }
        })
      }
    }
  },
  mounted(){
    let _this = this
    this.$axios.get('/api/wenlian/startcaptcha').then(res=>{
      this.session = res.data.sessionid
      console.log(!(!!res.data.success),!!res.data.new_captcha)
      initGeetest({
            // 以下配置参数来自服务端 SDK
            gt: res.data.gt,
            challenge: res.data.challenge,
            offline: !(!!res.data.success),
            new_captcha: !!res.data.new_captcha,
            product: 'bind'
        }, function (captchaObj) {
          captchaObj.onReady(function(){
        //验证码ready之后才能调用verify方法显示验证码
          }).onSuccess(function(){
              //your code
              _this.capt = captchaObj.getValidate()
              _this.sendCode()
          }).onError(function(){
              //your code
          })
          $('#btn').click(function () {
            if(!_this.codeDisable){
              if(_this.mobile){
                _this.errInfo = ""
                captchaObj.verify();
              }else{
                _this.errInfo = "请填写手机号"
              }
            }
          })
          // 这里可以调用验证实例 captchaObj 的实例方法
        })
    })
  }
}
</script>

<style lang="css">
.register .btn-send{
  padding: 0;
  line-height: 34px;
  margin-left: 20px;
}
.register .form-group .row{
  padding-right: 15px;
    padding-left: 15px;
}
.register .border{
  padding: 20px;
  border: 1px solid #333;
  border-radius: 5px;
}
.register .col-form-label{text-align: right;}
.register.middle-box h3{margin-bottom: 30px;color: #999}
.register.middle-box{max-width: 500px;}
.register.loginscreen{width: 100vh;height: 100vh;}
.register .text-link {color:#337ab7;font-size: 15px;}
.register.middle-box {
    z-index: 100;
    margin: 0 auto;
    padding-top: 150px;
}
.register.loginscreen.middle-box {
    width: 500px;
}
.register .btn-primary {
    background-color: #1ab394;
    border-color: #1ab394;
    color: #FFF;
    max-width: 500px;
}
.register .m-b {
    margin-bottom: 15px;
    margin-top  : 15px;
}
.register .full-width {
    width: 300px!important;
}
.register .text-muted {
    color: #888;
}
.register .text-muted {
    color: #777;
}
.register .form-control, .single-line {
    background-color: #FFF;
    background-image: none;
    border: 1px solid #e5e6e7;
    border-radius: 1px;
    color: inherit;
    display: block;
    padding: 6px 12px;
    -webkit-transition: border-color .15s ease-in-out 0s,box-shadow .15s ease-in-out 0s;
    transition: border-color .15s ease-in-out 0s,box-shadow .15s ease-in-out 0s;
    width: 100%;
    font-size: 14px;
}
.register .btn-primary:not(:disabled):not(.disabled).active, .btn-primary:not(:disabled):not(.disabled):active, .show>.btn-primary.dropdown-toggle{opacity: 0.5;background-color: #18a689;border-color: #18a689;}
.register .btn-primary{background-color: #18a689;border-color: #18a689;width: 200px;}
.register .btn-primary:hover{background-color: #1ab394;border-color: #1ab394;}
.register .btn-primary[disabled]{opacity: 0.5;background-color: #18a689;border-color: #18a689;}
@media screen and (max-width:640px){
  .register.loginscreen.middle-box{width: 90%;}
  .register.middle-box{padding-top: 20px;}
  .gray-bg{height: 100%;}
  .register .full-width{width: 100%!important;}
  .register .col-form-label{text-align: left;}
  .form-group{margin-bottom: 5px;}
  .register .btn-send{margin-left: 0;width: 100%;}
}
</style>



// WEBPACK FOOTER //
// src/components/register.vue